import { useState } from 'react'
import useLibraryNav from '~/src/hooks/useLibraryNav'

/**
 * Open state for the header's side menu, plus the header "Library" item, whose
 * lists the side menu also shows. Shared by the site headers so they all
 * behave the same.
 */
export default function useHeaderSheet() {
  const [isSheetOpen, setIsSheetOpen] = useState(false)
  const libraryNav = useLibraryNav()

  return {
    sheetProps: { isSheetOpen, setIsSheetOpen, library: libraryNav },
    libraryNav,
  }
}
